// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamSales_Team_search_baar__KLv0o {
  width: 400px;
  border-radius: 5px;
}

.TeamSales_team_Sales_search_section__Lwn9G {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
  flex-wrap: wrap;
}
.TeamSales_team_sales_add_button__FKw18 {
  display: flex;
  gap: 15px;
}
.TeamSales_team_sales_add_button__FKw18 button {
  height: 45px;
  width: 150px;
  background-color: #02337b;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* Modal Overlay */
.TeamSales_Add_employe_modal_overlay__KG4po {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.TeamSales_Add_employe_modal_content__\\+BOSU {
  background: white;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
}

/* Close Button */
.TeamSales_Add_employe_close_button__IeqbL {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #333;
}

/* Form Styling */
.TeamSales_Add_employe_form__qyKax {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

/* Input Fields */
.TeamSales_Add_employee_input__sNLTF,
.TeamSales_Add_employee_select_input__XRnNG {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  transition: all 0.3s ease;
}

.TeamSales_Add_employee_input__sNLTF:focus,
.TeamSales_Add_employee_select_input__XRnNG:focus {
  border-color: #007bff;
}

/* Submit Button */
.TeamSales_Add_employe_submit_button__V9vd1 {
  background: #007bff;
  color: white;
  padding: 10px;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.TeamSales_Add_employe_submit_button__V9vd1:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .TeamSales_Add_employe_modal_content__\\+BOSU {
    width: 95%;
    padding: 15px;
  }

  .TeamSales_Add_employee_input__sNLTF,
  .TeamSales_Add_employee_select_input__XRnNG {
    font-size: 14px;
    padding: 8px;
  }

  .TeamSales_Add_employe_submit_button__V9vd1 {
    font-size: 16px;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .TeamSales_Add_employe_modal_content__\\+BOSU {
    width: 100%;
    border-radius: 0;
  }

  .TeamSales_Add_employee_input__sNLTF,
  .TeamSales_Add_employee_select_input__XRnNG {
    font-size: 14px;
  }

  .TeamSales_Add_employe_submit_button__V9vd1 {
    font-size: 14px;
  }
}

/* create gropu */
.TeamSales_create_group_form__xwdLm {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}
.TeamSales_create_group_modal_overlay__do9aN {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamSales_create_group_modal_content__JuV4s {
  background: white;
  width: 90%;
  max-width: 450px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
}

.TeamSales_create_group_close_button__P4fp2 {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #333;
}

.TeamSales_create_group_form__xwdLm {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

.TeamSales_create_group_input_field__O4F25,
.TeamSales_create_group_select_field__zEcAI {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  transition: all 0.3s ease;
}

.TeamSales_create_group_input_field__O4F25:focus,
.TeamSales_create_group_select_field__zEcAI:focus {
  border-color: #007bff;
}

.TeamSales_create_group_select_field__zEcAI {
  background: white;
}

.TeamSales_create_group_select_field__zEcAI[multiple] {
  height: 100px;
  overflow-y: auto;
}

.TeamSales_create_group_submit_button__qHtfF {
  background: #007bff;
  color: white;
  padding: 10px;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.TeamSales_create_group_submit_button__qHtfF:hover {
  background: #0056b3;
}

.TeamSales_create_group_submit_button__qHtfF:disabled {
  background: #ccc;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .TeamSales_create_group_modal_content__JuV4s {
    width: 95%;
    padding: 15px;
  }

  .TeamSales_create_group_input_field__O4F25,
  .TeamSales_create_group_select_field__zEcAI {
    font-size: 14px;
    padding: 8px;
  }

  .TeamSales_create_group_submit_button__qHtfF {
    font-size: 16px;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .TeamSales_create_group_modal_content__JuV4s {
    width: 100%;
    border-radius: 0;
  }

  .TeamSales_create_group_input_field__O4F25,
  .TeamSales_create_group_select_field__zEcAI {
    font-size: 14px;
  }

  .TeamSales_create_group_submit_button__qHtfF {
    font-size: 14px;
  }
}

/* group name */
.TeamSales_All_gropu_container__Ob9Id {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  padding: 20px;
  justify-items: center;
  margin-top: 25px;
}

.TeamSales_groupContainer__hdgfa {
  width: 100%;
  max-width: 200px;
  text-align: center;
}

.TeamSales_groupButton__JMk8Z {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  background: #007bff;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.TeamSales_groupButton__JMk8Z:hover {
  background: #0056b3;
  transform: scale(1.05);
}

.TeamSales_noGroups__c\\+4rK {
  text-align: center;
  font-size: 18px;
  color: gray;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .TeamSales_All_gropu_container__Ob9Id {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 10px;
  }

  .TeamSales_groupButton__JMk8Z {
    font-size: 14px;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .TeamSales_All_gropu_container__Ob9Id {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 8px;
  }

  .TeamSales_groupButton__JMk8Z {
    font-size: 13px;
    padding: 8px;
  }
}

/* team table */
.TeamSales_teamSales_table_container__5Y\\+yl {
  width: 100%;
  overflow-x: auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.TeamSales_teamSales_group_table__fgcCD {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.TeamSales_teamSales_group_table__fgcCD th,
.TeamSales_teamSales_group_table__fgcCD td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  border: 1px solid #eee;
}

.TeamSales_teamSales_group_table__fgcCD thead {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.TeamSales_teamSales_group_table__fgcCD tbody tr:nth-child(even) {
  background-color: #f2f2f2; /* Alternating row color */
}

.TeamSales_leader_row__6\\+LbM {
  background-color: #d1e7ff !important; /* Highlight leader */
  font-weight: bold;
}

.TeamSales_member_row__VWRqg {
  background-color: #ffffff;
}

.TeamSales_no_data__chYkL {
  text-align: center;
  font-weight: bold;
  color: red;
  padding: 15px;
}

/* Buttons */
.TeamSales_teamSales_group_table_delete_button__3GXYh button {
  padding: 6px 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}

.TeamSales_teamSales_group_table_delete_button__3GXYh button:hover {
  opacity: 0.8;
}

.TeamSales_teamSales_group_table_delete_button__3GXYh {
  background-color: #dc3545;
  padding: 6px 12px;
  border-radius: 5px;
  border: none;
  color: white;
}

.TeamSales_teamSales_group_table_delete_button__3GXYh:hover {
  background-color: #c82333;
}

.TeamSales_teamSales_group_table_view_button__CfMA9 {
  background-color: #28a745;
  padding: 6px 12px;
  border: none;
  color: white;
  border-radius: 5px;
}

.TeamSales_teamSales_group_table_view_button__CfMA9:hover {
  background-color: #218838;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .TeamSales_teamSales_group_table__fgcCD th,
  .TeamSales_teamSales_group_table__fgcCD td {
    padding: 8px;
    font-size: 12px;
  }

  button {
    font-size: 12px;
    padding: 4px 8px;
  }
}

/* Overlay to darken background */
.TeamSales_change_leader_popup_overlay__l3-tn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Dark transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Popup content box */
.TeamSales_change_leader_popup_content__gw6mg {
  background: white;
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  position: relative;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  animation: TeamSales_fadeIn__KXHs6 0.3s ease-in-out;
}

/* Smooth fade-in animation */
@keyframes TeamSales_fadeIn__KXHs6 {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Close button */
.TeamSales_close_change_leader_form__1tQ9Y {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* Form styling */
.TeamSales_change_leader_form__wxvr5 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.TeamSales_change_leader_form_title__Y6sRR {
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
}

.TeamSales_change_leader_form_select__t5k5a {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.TeamSales_change_leader_form_submit_button__P9qT9 {
  background: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.TeamSales_change_leader_form_submit_button__P9qT9:hover {
  background: #0056b3;
}

/* *********** */

.TeamSales_allGroupContainer__hR7nJ {
  /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 20px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  gap: 25px;
  margin-top: 30px;
  margin-bottom: 20px;
}

.TeamSales_groupCard__wDncL {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.TeamSales_groupCard__wDncL:hover {
  transform: translateY(-5px);
}

.TeamSales_groupName__UqupE {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.TeamSales_buttonContainer__cqN66 {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.TeamSales_viewButton__SuZm-,
.TeamSales_editButton__nyFEt,
.TeamSales_deleteButton__aSUav {
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: 0.3s;
}

.TeamSales_viewButton__SuZm- {
  background-color: #007bff;
  color: white;
}

.TeamSales_editButton__nyFEt {
  background-color: #ffc107;
  color: black;
}

.TeamSales_deleteButton__aSUav {
  background-color: #dc3545;
  color: white;
}

.TeamSales_viewButton__SuZm-:hover {
  background-color: #0056b3;
}

.TeamSales_editButton__nyFEt:hover {
  background-color: #e0a800;
}

.TeamSales_deleteButton__aSUav:hover {
  background-color: #c82333;
}

.TeamSales_noGroups__c\\+4rK {
  text-align: center;
  font-size: 16px;
  color: #666;
}

/* Background overlay */
.TeamSales_edit_groupName_overlay__72dcB {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Dim background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal box */
.TeamSales_edit_groupName_modal__NTi\\+d {
  background: white;
  width: 350px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
}

/* Close button */
.TeamSales_edit_groupName_close__kxIhq {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* Title */
.TeamSales_edit_groupName_title__m-YSh {
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: bold;
}

/* Form input */
.TeamSales_edit_groupName_form_input__Tssdj {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

/* Submit button */
.TeamSales_edit_groupName_form_submit_button__Q9DA7 {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.TeamSales_edit_groupName_form_submit_button__Q9DA7:hover {
  background-color: #0056b3;
}

.TeamSales_add_memberContainer__Xvk80 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TeamSales_add_memberModal__FBsXZ {
  background: #ffffff;
  border-radius: 10px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.TeamSales_add_memberHeader__FAWbN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.TeamSales_add_memberHeader__FAWbN h3 {
  margin: 0;
  color: #007bff;
  font-size: 1.5rem;
  font-weight: 500;
}

.TeamSales_add_memberCloseButton__ripEk {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: color 0.3s ease;
}

.TeamSales_add_memberCloseButton__ripEk:hover {
  color: #007bff;
}

.TeamSales_add_memberForm__2pDOh {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.TeamSales_add_member_form_select__onw6m {
  padding: 0.8rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #444444;
  background: #f8f9fa;
  width: 100%;
}

.TeamSales_add_member_form_select__onw6m:focus {
  border-color: #007bff;
  outline: none;
}

.TeamSales_add_member_submit_button__A3tnF {
  background: #007bff;
  color: #ffffff;
  border: none;
  padding: 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.TeamSales_add_member_submit_button__A3tnF:hover {
  background: #007bff;
}

@media (max-width: 768px) {
  .TeamSales_add_memberModal__FBsXZ {
    width: 95%;
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .TeamSales_add_memberHeader__FAWbN h3 {
    font-size: 1.2rem;
  }

  .TeamSales_add_memberModal__FBsXZ {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/TeamSales.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,gCAAgC;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mDAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE;;;kBAGgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,mBAAmB;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".Team_search_baar {\n  width: 400px;\n  border-radius: 5px;\n}\n\n.team_Sales_search_section {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 30px;\n  flex-wrap: wrap;\n}\n.team_sales_add_button {\n  display: flex;\n  gap: 15px;\n}\n.team_sales_add_button button {\n  height: 45px;\n  width: 150px;\n  background-color: #02337b;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* Modal Overlay */\n.Add_employe_modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal Content */\n.Add_employe_modal_content {\n  background: white;\n  width: 90%;\n  max-width: 500px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  text-align: center;\n}\n\n/* Close Button */\n.Add_employe_close_button {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  border: none;\n  background: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #333;\n}\n\n/* Form Styling */\n.Add_employe_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n/* Input Fields */\n.Add_employee_input,\n.Add_employee_select_input {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.Add_employee_input:focus,\n.Add_employee_select_input:focus {\n  border-color: #007bff;\n}\n\n/* Submit Button */\n.Add_employe_submit_button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  font-size: 18px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.Add_employe_submit_button:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .Add_employe_modal_content {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .Add_employee_input,\n  .Add_employee_select_input {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .Add_employe_submit_button {\n    font-size: 16px;\n    padding: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .Add_employe_modal_content {\n    width: 100%;\n    border-radius: 0;\n  }\n\n  .Add_employee_input,\n  .Add_employee_select_input {\n    font-size: 14px;\n  }\n\n  .Add_employe_submit_button {\n    font-size: 14px;\n  }\n}\n\n/* create gropu */\n.create_group_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 10px;\n}\n.create_group_modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.create_group_modal_content {\n  background: white;\n  width: 90%;\n  max-width: 450px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  text-align: center;\n}\n\n.create_group_close_button {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  border: none;\n  background: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #333;\n}\n\n.create_group_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.create_group_input_field,\n.create_group_select_field {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.create_group_input_field:focus,\n.create_group_select_field:focus {\n  border-color: #007bff;\n}\n\n.create_group_select_field {\n  background: white;\n}\n\n.create_group_select_field[multiple] {\n  height: 100px;\n  overflow-y: auto;\n}\n\n.create_group_submit_button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  font-size: 18px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.create_group_submit_button:hover {\n  background: #0056b3;\n}\n\n.create_group_submit_button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .create_group_modal_content {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .create_group_input_field,\n  .create_group_select_field {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .create_group_submit_button {\n    font-size: 16px;\n    padding: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .create_group_modal_content {\n    width: 100%;\n    border-radius: 0;\n  }\n\n  .create_group_input_field,\n  .create_group_select_field {\n    font-size: 14px;\n  }\n\n  .create_group_submit_button {\n    font-size: 14px;\n  }\n}\n\n/* group name */\n.All_gropu_container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  padding: 20px;\n  justify-items: center;\n  margin-top: 25px;\n}\n\n.groupContainer {\n  width: 100%;\n  max-width: 200px;\n  text-align: center;\n}\n\n.groupButton {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  background: #007bff;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.groupButton:hover {\n  background: #0056b3;\n  transform: scale(1.05);\n}\n\n.noGroups {\n  text-align: center;\n  font-size: 18px;\n  color: gray;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  .All_gropu_container {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 10px;\n  }\n\n  .groupButton {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .All_gropu_container {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 8px;\n  }\n\n  .groupButton {\n    font-size: 13px;\n    padding: 8px;\n  }\n}\n\n/* team table */\n.teamSales_table_container {\n  width: 100%;\n  overflow-x: auto;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.teamSales_group_table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.teamSales_group_table th,\n.teamSales_group_table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  border: 1px solid #eee;\n}\n\n.teamSales_group_table thead {\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.teamSales_group_table tbody tr:nth-child(even) {\n  background-color: #f2f2f2; /* Alternating row color */\n}\n\n.leader_row {\n  background-color: #d1e7ff !important; /* Highlight leader */\n  font-weight: bold;\n}\n\n.member_row {\n  background-color: #ffffff;\n}\n\n.no_data {\n  text-align: center;\n  font-weight: bold;\n  color: red;\n  padding: 15px;\n}\n\n/* Buttons */\n.teamSales_group_table_delete_button button {\n  padding: 6px 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n.teamSales_group_table_delete_button button:hover {\n  opacity: 0.8;\n}\n\n.teamSales_group_table_delete_button {\n  background-color: #dc3545;\n  padding: 6px 12px;\n  border-radius: 5px;\n  border: none;\n  color: white;\n}\n\n.teamSales_group_table_delete_button:hover {\n  background-color: #c82333;\n}\n\n.teamSales_group_table_view_button {\n  background-color: #28a745;\n  padding: 6px 12px;\n  border: none;\n  color: white;\n  border-radius: 5px;\n}\n\n.teamSales_group_table_view_button:hover {\n  background-color: #218838;\n}\n\n/* Responsive Design */\n@media screen and (max-width: 768px) {\n  .teamSales_group_table th,\n  .teamSales_group_table td {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  button {\n    font-size: 12px;\n    padding: 4px 8px;\n  }\n}\n\n/* Overlay to darken background */\n.change_leader_popup_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Dark transparent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Popup content box */\n.change_leader_popup_content {\n  background: white;\n  width: 90%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  position: relative;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Smooth fade-in animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Close button */\n.close_change_leader_form {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n/* Form styling */\n.change_leader_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.change_leader_form_title {\n  font-size: 18px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.change_leader_form_select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.change_leader_form_submit_button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.change_leader_form_submit_button:hover {\n  background: #0056b3;\n}\n\n/* *********** */\n\n.allGroupContainer {\n  /* display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n  padding: 20px; */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 20px;\n  gap: 25px;\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.groupCard {\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.groupCard:hover {\n  transform: translateY(-5px);\n}\n\n.groupName {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.viewButton,\n.editButton,\n.deleteButton {\n  border: none;\n  padding: 8px 12px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: 0.3s;\n}\n\n.viewButton {\n  background-color: #007bff;\n  color: white;\n}\n\n.editButton {\n  background-color: #ffc107;\n  color: black;\n}\n\n.deleteButton {\n  background-color: #dc3545;\n  color: white;\n}\n\n.viewButton:hover {\n  background-color: #0056b3;\n}\n\n.editButton:hover {\n  background-color: #e0a800;\n}\n\n.deleteButton:hover {\n  background-color: #c82333;\n}\n\n.noGroups {\n  text-align: center;\n  font-size: 16px;\n  color: #666;\n}\n\n/* Background overlay */\n.edit_groupName_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Dim background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal box */\n.edit_groupName_modal {\n  background: white;\n  width: 350px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  position: relative;\n}\n\n/* Close button */\n.edit_groupName_close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Title */\n.edit_groupName_title {\n  font-size: 20px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n/* Form input */\n.edit_groupName_form_input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n/* Submit button */\n.edit_groupName_form_submit_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s;\n}\n\n.edit_groupName_form_submit_button:hover {\n  background-color: #0056b3;\n}\n\n.add_memberContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.add_memberModal {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 2rem;\n  width: 90%;\n  max-width: 400px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.add_memberHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 1rem;\n}\n\n.add_memberHeader h3 {\n  margin: 0;\n  color: #007bff;\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n\n.add_memberCloseButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  transition: color 0.3s ease;\n}\n\n.add_memberCloseButton:hover {\n  color: #007bff;\n}\n\n.add_memberForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.add_member_form_select {\n  padding: 0.8rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  color: #444444;\n  background: #f8f9fa;\n  width: 100%;\n}\n\n.add_member_form_select:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.add_member_submit_button {\n  background: #007bff;\n  color: #ffffff;\n  border: none;\n  padding: 0.8rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.add_member_submit_button:hover {\n  background: #007bff;\n}\n\n@media (max-width: 768px) {\n  .add_memberModal {\n    width: 95%;\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_memberHeader h3 {\n    font-size: 1.2rem;\n  }\n\n  .add_memberModal {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Team_search_baar": `TeamSales_Team_search_baar__KLv0o`,
	"team_Sales_search_section": `TeamSales_team_Sales_search_section__Lwn9G`,
	"team_sales_add_button": `TeamSales_team_sales_add_button__FKw18`,
	"Add_employe_modal_overlay": `TeamSales_Add_employe_modal_overlay__KG4po`,
	"Add_employe_modal_content": `TeamSales_Add_employe_modal_content__+BOSU`,
	"Add_employe_close_button": `TeamSales_Add_employe_close_button__IeqbL`,
	"Add_employe_form": `TeamSales_Add_employe_form__qyKax`,
	"Add_employee_input": `TeamSales_Add_employee_input__sNLTF`,
	"Add_employee_select_input": `TeamSales_Add_employee_select_input__XRnNG`,
	"Add_employe_submit_button": `TeamSales_Add_employe_submit_button__V9vd1`,
	"create_group_form": `TeamSales_create_group_form__xwdLm`,
	"create_group_modal_overlay": `TeamSales_create_group_modal_overlay__do9aN`,
	"create_group_modal_content": `TeamSales_create_group_modal_content__JuV4s`,
	"create_group_close_button": `TeamSales_create_group_close_button__P4fp2`,
	"create_group_input_field": `TeamSales_create_group_input_field__O4F25`,
	"create_group_select_field": `TeamSales_create_group_select_field__zEcAI`,
	"create_group_submit_button": `TeamSales_create_group_submit_button__qHtfF`,
	"All_gropu_container": `TeamSales_All_gropu_container__Ob9Id`,
	"groupContainer": `TeamSales_groupContainer__hdgfa`,
	"groupButton": `TeamSales_groupButton__JMk8Z`,
	"noGroups": `TeamSales_noGroups__c+4rK`,
	"teamSales_table_container": `TeamSales_teamSales_table_container__5Y+yl`,
	"teamSales_group_table": `TeamSales_teamSales_group_table__fgcCD`,
	"leader_row": `TeamSales_leader_row__6+LbM`,
	"member_row": `TeamSales_member_row__VWRqg`,
	"no_data": `TeamSales_no_data__chYkL`,
	"teamSales_group_table_delete_button": `TeamSales_teamSales_group_table_delete_button__3GXYh`,
	"teamSales_group_table_view_button": `TeamSales_teamSales_group_table_view_button__CfMA9`,
	"change_leader_popup_overlay": `TeamSales_change_leader_popup_overlay__l3-tn`,
	"change_leader_popup_content": `TeamSales_change_leader_popup_content__gw6mg`,
	"fadeIn": `TeamSales_fadeIn__KXHs6`,
	"close_change_leader_form": `TeamSales_close_change_leader_form__1tQ9Y`,
	"change_leader_form": `TeamSales_change_leader_form__wxvr5`,
	"change_leader_form_title": `TeamSales_change_leader_form_title__Y6sRR`,
	"change_leader_form_select": `TeamSales_change_leader_form_select__t5k5a`,
	"change_leader_form_submit_button": `TeamSales_change_leader_form_submit_button__P9qT9`,
	"allGroupContainer": `TeamSales_allGroupContainer__hR7nJ`,
	"groupCard": `TeamSales_groupCard__wDncL`,
	"groupName": `TeamSales_groupName__UqupE`,
	"buttonContainer": `TeamSales_buttonContainer__cqN66`,
	"viewButton": `TeamSales_viewButton__SuZm-`,
	"editButton": `TeamSales_editButton__nyFEt`,
	"deleteButton": `TeamSales_deleteButton__aSUav`,
	"edit_groupName_overlay": `TeamSales_edit_groupName_overlay__72dcB`,
	"edit_groupName_modal": `TeamSales_edit_groupName_modal__NTi+d`,
	"edit_groupName_close": `TeamSales_edit_groupName_close__kxIhq`,
	"edit_groupName_title": `TeamSales_edit_groupName_title__m-YSh`,
	"edit_groupName_form_input": `TeamSales_edit_groupName_form_input__Tssdj`,
	"edit_groupName_form_submit_button": `TeamSales_edit_groupName_form_submit_button__Q9DA7`,
	"add_memberContainer": `TeamSales_add_memberContainer__Xvk80`,
	"add_memberModal": `TeamSales_add_memberModal__FBsXZ`,
	"add_memberHeader": `TeamSales_add_memberHeader__FAWbN`,
	"add_memberCloseButton": `TeamSales_add_memberCloseButton__ripEk`,
	"add_memberForm": `TeamSales_add_memberForm__2pDOh`,
	"add_member_form_select": `TeamSales_add_member_form_select__onw6m`,
	"add_member_submit_button": `TeamSales_add_member_submit_button__A3tnF`
};
export default ___CSS_LOADER_EXPORT___;
